//the severity is return by risk
export const SEVERITY = {
  VERY_LOW: 1,
  LOW: 2,
  MEDIUM: 3,
  HIGH: 4,
  VERY_HIGH: 5,
  NONE: 0,
};
// for the history heatmap without combined severity
export const getSeverityByCoverage = (coverage) => {
  if (coverage <= 40) {
    return SEVERITY.VERY_HIGH;
  }
  if (coverage <= 60) {
    return SEVERITY.HIGH;
  }
  if (coverage <= 80) {
    return SEVERITY.MEDIUM;
  }
  if (coverage < 99) {
    return SEVERITY.LOW;
  }
  if (coverage >= 99) {
    return SEVERITY.VERY_LOW;
  }
  return SEVERITY.NONE; //coverage 100
};

// Severity labels for consistent terminology
export const RISK_LABELS = {
  [SEVERITY.NONE]: "Not applicable",
  [SEVERITY.VERY_LOW]: "Very Low",
  [SEVERITY.LOW]: "Low",
  [SEVERITY.MEDIUM]: "Medium",
  [SEVERITY.HIGH]: "High",
  [SEVERITY.VERY_HIGH]: "Very High",
};
export const CoverageLabels = {
  [SEVERITY.NONE]: "Not applicable",
  [SEVERITY.VERY_LOW]: "Low",
  [SEVERITY.LOW]: "Below average",
  [SEVERITY.MEDIUM]: "Medium",
  [SEVERITY.HIGH]: "Above average",
  [SEVERITY.VERY_HIGH]: "Optimal",
};

export const getRiskLabel = (value) => {
  return RISK_LABELS[value] || RISK_LABELS[SEVERITY.VERY_LOW];
};

export const getCoverageLabel = (value) => {
  return CoverageLabels[value] || CoverageLabels[SEVERITY.VERY_LOW];
};

// Generic function to get color based on value, type and labels mapping
const getColorByType = (value, colors, type, trendData = false) => {
  const isCoverage = type === "coverage";

  const colorMapping = {
    // Coverage: Higher is better (low → high)
    coverage: {
      [CoverageLabels[SEVERITY.NONE]]: colors.ops_heatmap_not_applicable,
      [CoverageLabels[SEVERITY.VERY_LOW]]: colors.ops_heatmap_low,
      [CoverageLabels[SEVERITY.LOW]]: colors.ops_heatmap_below_average,
      [CoverageLabels[SEVERITY.MEDIUM]]: colors.ops_heatmap_medium,
      [CoverageLabels[SEVERITY.HIGH]]: colors.ops_heatmap_above_average,
      [CoverageLabels[SEVERITY.VERY_HIGH]]: colors.ops_heatmap_optimal,
    },
    // Risk: Lower is better (high → low)
    risk: {
      [RISK_LABELS[SEVERITY.NONE]]: colors.ops_heatmap_not_applicable,
      [RISK_LABELS[SEVERITY.VERY_LOW]]: colors.ops_heatmap_optimal,
      [RISK_LABELS[SEVERITY.LOW]]: colors.ops_heatmap_above_average,
      [RISK_LABELS[SEVERITY.MEDIUM]]: colors.ops_heatmap_medium,
      [RISK_LABELS[SEVERITY.HIGH]]: colors.ops_heatmap_below_average,
      [RISK_LABELS[SEVERITY.VERY_HIGH]]: colors.ops_heatmap_low,
    },
  };

  const getLabel = isCoverage ? getCoverageLabel : getRiskLabel;
  const label = getLabel(value);
  return colorMapping[type][label];
};

// Helper function to convert color to rgba with opacity
const addOpacityToColor = (color, opacity = 0.3) => {
  // If already rgba, modify the alpha value
  if (color.startsWith("rgba")) {
    return color.replace(/[\d\.]+\)$/g, `${opacity})`);
  }

  // If rgb, convert to rgba
  if (color.startsWith("rgb")) {
    return color.replace("rgb", "rgba").replace(")", `, ${opacity})`);
  }

  // If hex, convert to rgba
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // Fallback: return original color
  return color;
};

// Function to get color based on coverage value
export const getCoverageColor = (value, colors, trendData = false, opacityDisabled = false) => {
  const baseColor = getColorByType(value, colors, "coverage");

  // Add opacity when trend data is present and opacity is not disabled
  if (trendData && !opacityDisabled) {
    return addOpacityToColor(baseColor, 0.15);
  }

  return baseColor;
};

// Function to get color based on risk value
export const getRiskColor = (value, colors, trendData = false, opacityDisabled = false) => {
  const baseColor = getColorByType(value, colors, "risk");

  // Add opacity when trend data is present and opacity is not disabled
  if (trendData && !opacityDisabled) {
    return addOpacityToColor(baseColor, 0.15);
  }

  return baseColor;
};
